import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Input from "../general/input";

const JoinViberateModule = ({ index, name }) => {
  return (
    <div className="box-body">
      <div className="row">
        <div className="col-md-12">
          <div className="fomr-group">
            <div className="input-group">
              <Input
                className="form-control"
                placeholder="Headline"
                name={`${name}.[${index}].data.headline`}
                showClearInputButton={false}
                debounceTime={0}
              />
              <Input
                className="form-control"
                placeholder="Subtext"
                name={`${name}.[${index}].data.subtext`}
                showClearInputButton={false}
                debounceTime={0}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

JoinViberateModule.propTypes = {
  index: PropTypes.number,
  name: PropTypes.string,
};

export default connect()(JoinViberateModule);
